.Form__Checkbox {
  margin: $gutter-xxsmall 0;
  overflow: hidden;
  user-select: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  
  small {
    color: $color-base;
  }

  &--default {
    flex: 1 0 auto;
    align-items: center;

    h6 {
      color: $color-black;
    }
  }
  
  &--large {
    flex: 0 0 auto;
  }

  &:not([disabled]) {
    cursor: pointer;

    &:hover .Form__Checkbox__input:not(.Form__Checkbox__input--checked) {
      border: 1px solid darken($color-border, 15%);
    }
  }

  &[disabled] {
    color: $color-darkgrey;

    h6, small {
      color: $color-darkgrey;
    }

    .Form__Checkbox__input {
      border: 1px solid $color-border;
      background-color: $color-grey-10;

      &.Form__Checkbox__input--checked {
        background-color: $color-grey-40;
        border: 1px solid $color-grey-40;
      }
    }
  }

  &.Form__Checkbox--invalid {
    .Form__Checkbox__input {
      border: 1px solid $color-red;
    }

    h6, .Form__Checkbox__label {
      color: $color-red;

      small {
        color: rgba($color-red, 0.6);
      }
    }
  }

  &--default .Form__Checkbox__input {
    width: $checkbox-size;
    height: $checkbox-size;

    &:not(:last-child) {
      margin-right: $gutter-xsmall;
    }

    .Icon {
      width: $checkbox-size;
      height: $checkbox-size;
    }
  }
  
  &--large .Form__Checkbox__input {
    width: 18px;
    height: 18px;

    &:not(:last-child) {
      margin-right: $gutter-xsmall;
    }

    .Icon {
      width: 18px;
      height: 18px;
    }
  }

  .Form__Checkbox__input {
    border-radius: $border-radius-button-base;
    border: 1px solid $color-border;

    &.Form__Checkbox__input--checked {
      background-color: $color-primary;
      border: 1px solid $color-primary;
    }

    .Icon {
      @include iconColor($color-white);
    }
  }

  &--default .Form__Checkbox__label small {
    display: block;
  }

  .Form__Checkbox__label {
    flex: 1;

    .Icon {
      @include iconColor($color-base);
      margin: 2px 0 0 $gutter-xxsmall;
      float: right;
      width: 16px;
      height: 16px;
    }
    
    .AlertText {
      margin-top: -2px;
      display: inline-block;

      .Icon {
        @include iconColor($color-orange);
        margin-top: 0;
        float: none;
        position: relative;
        top: 3px;
      }
    }
  }
}

.Form__Row .List .Form__Checkbox {
  margin: $gutter-xxsmall 0;
}

.Form__Row .Form__Checkbox {
  margin: 0;
}

.Table__Cell .Form__Checkbox {
  margin: 0;
}

.dark .Form__Checkbox {
  small {
    color: var(--text-paragraph-2);
  }

  &--default h6,
  .Form__Checkbox__label {
    color: var(--text-heading);
  }

  .Form__Checkbox__input {
    // `--border` matches overlay/dropdown surfaces (#27272A) and disappears;
    // use the bolder token so unchecked boxes stay visible.
    border-color: var(--border-bold, #52525B);
    background-color: transparent;

    &.Form__Checkbox__input--checked {
      background-color: $color-primary;
      border-color: $color-primary;
    }
  }

  &:not([disabled]):hover .Form__Checkbox__input:not(.Form__Checkbox__input--checked) {
    border-color: var(--border-bolder, #71717A);
  }

  .Form__Checkbox__label .Icon {
    @include iconColor(var(--text-paragraph-2));
  }

  // Must follow the rules above so disabled beats heading/primary colors.
  // Prefer paragraph-3 over --text-disabled (#52525B), which is too faint on cards.
  &[disabled] {
    color: var(--text-paragraph-3);

    h6,
    small,
    .Form__Checkbox__label {
      color: var(--text-paragraph-3);
    }

    .Form__Checkbox__input {
      border-color: var(--border-bold, #52525B);
      background-color: var(--bg-surface-overlay);

      &.Form__Checkbox__input--checked {
        background-color: var(--border-bolder, #71717A);
        border-color: var(--border-bolder, #71717A);
      }

      .Icon {
        @include iconColor(#FAFAFA);
      }
    }
  }
}
